import { useMutation } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { AxiosError } from "axios"
import { API_IDENTIFICATION_URL, IDENTIFICATION_NON_CRITICAL_ERRORS } from "../constants"
import { IdentificationByPassportRequest } from "../../types/identification"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"
import { IIdentificationResponse } from "../../pages/RegistrationOtpConfirmation/hooks/interface"
import { RootState } from "../../store/store"


const identificationByPassport = async (token: string | null, request: IdentificationByPassportRequest) => {
  try {
    const response = await axios(API_IDENTIFICATION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: request,
    })

    return response.data
  } catch (error) {
    if (error instanceof AxiosError) {
      const { response } = error

      if (response?.data && IDENTIFICATION_NON_CRITICAL_ERRORS.includes(response.data.error)) {
        return response.data
      }

      if (response?.data && checkIsFailure(response?.data?.status)) {
        throw new Error(
          `Ошибка при запросе данных: ${response.data.status} - ${response.data.detail}`,
        )
      }
    }
    throw error
  }
}

export const useIdentificationByPassport = () => {
  const navigate = useNavigate()
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation<IIdentificationResponse, Error, IdentificationByPassportRequest>({
    mutationFn: (request) => identificationByPassport(token, request),
    onError: () => {
      navigate("/error")
    },
  })

}